// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiURL:   "https://sat-backend-api-manager.azure-api.net/umbraco/api/",
  apiTravelWeekURL: "https://twregistrationfunction.azurewebsites.net/api/satregistration",
  googleMapsAPI: "AIzaSyCXTTbwxfmTAeMSN5Hu1NUzqivZWtUE9Y4",
  appVersion: "2.14",
  //DealUrl: "https://tradeplatform-qaapi.azurewebsites.net/api/v1/Products/GetOpenDeals",
  DealUrl: "https://tradeplatform-liveapi.azurewebsites.net/api/v1/Products/GetOpenDeals",
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
